"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Text = exports.Root = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const DEFAULT_HEIGHT = 250;
const DEFAULT_HEIGHT_MOBILE = 210;
const Root = exports.Root = (0, _mui.styled)('div', {
    shouldForwardProp: (0, _presentationUtils.shouldForwardProp)([
        'height'
    ])
})((param)=>{
    let { backgroundColor, titleColor, theme } = param;
    return {
        backgroundColor,
        color: titleColor,
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        overflow: 'hidden',
        justifyContent: 'center',
        height: DEFAULT_HEIGHT_MOBILE,
        padding: 0,
        [theme.breakpoints.up('sm')]: {
            height: DEFAULT_HEIGHT,
            padding: theme.spacing(2, 0)
        }
    };
});
const Text = exports.Text = (0, _mui.styled)(_mui.Typography)((param)=>{
    let { theme, variant } = param;
    return {
        width: '100%',
        display: '-webkit-box',
        WebkitLineClamp: variant === 'h5' ? 6 : 7,
        lineClamp: variant === 'h5' ? 6 : 7,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        maxHeight: DEFAULT_HEIGHT_MOBILE,
        color: theme.palette.text.primary,
        margin: theme.spacing(3),
        [theme.breakpoints.up('sm')]: {
            width: 600,
            margin: 0
        }
    };
});
